import { ScrollDispatcher } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WINDOW } from '@app/common/app-tokens';
import { Link } from '@app/models/link';
import { LinkModule } from '@app/directives/link.directive';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-table-of-contents',
  templateUrl: './table-of-contents.component.html',
  styleUrls: ['./table-of-contents.component.scss'],
})
export class TableOfContentsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() selectors: string;
  links = new Array<Link>();
  scrollingSubscription: Subscription;

  constructor(private scroll: ScrollDispatcher,
              @Inject(DOCUMENT) private document: Document,
              @Inject(WINDOW) private window: Window,
              private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.scrollingSubscription = this.scroll
      .scrolled() // This event is throttled so there may be a slight lag when scrolling up and down and setting the active link.
      .subscribe(() => {
        this.onScroll();
      });
  }

  ngAfterViewInit(): void {
    this.document
      .querySelectorAll(this.selectors)
      .forEach((header: HTMLElement) => {
        const name = header.attributes['data-letter'].value;
        const rect = header.getBoundingClientRect();
        this.links.push({
          name,
          type: header.tagName.toLowerCase(),
          top: this.window.pageYOffset + (rect.top - rect.height),
          id: header.id,
          active: false
        });
      });
  }

  private onScroll(): void {

    const inView = [];
    const screenTop = this.window.pageYOffset;
    const screenBottom = this.window.pageYOffset + this.window.innerHeight;
    this.document
      .querySelectorAll(this.selectors)
      .forEach((header: HTMLElement) => {
        const id = header.id;
        const rect = header.getBoundingClientRect();
        const top = this.window.pageYOffset + (rect.top);
        const bottom = this.window.pageYOffset + (rect.top + rect.height) - 1;
        if (bottom > (screenTop + 40) && top < (screenBottom - 40)) { // 40 are margins, subjectively chosen to look nice
          inView.push(id);
        }
      });

    this.links.forEach(link => {
      link.active = inView.includes(link.id);
    });

    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.scrollingSubscription && this.scrollingSubscription.unsubscribe();
  }
}

@NgModule({
  declarations: [TableOfContentsComponent],
  imports: [
    CommonModule,
    RouterModule,
    LinkModule,
    ScrollingModule
  ],
  exports: [TableOfContentsComponent]
})
export class TableOfContentsModule { }
